










































































import { defineComponent, reactive, toRefs, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SearchCondition, Sheet } from "../../modules/teacher/SheetDestroy"
import { create } from 'lodash';


export interface Data {
  condition: SearchCondition
  sheets: Sheet[]
  isAllCheckedDelete: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      sheets: [],
      isAllCheckedDelete: false,
      errors: [],
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      state.errors = [];

      if(!state.condition.created_at_to){
        state.errors.push("作成日Toは必須です");
        return;
      }

      let createdAtTo = new Date(state.condition.created_at_to);
      
      if(createdAtTo.getTime() > new Date(getSearchLimitDate()).getTime()){
        state.errors.push("作成日Toは1年前以前にしてください。");
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_destroy?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };


    /******************************
     * 削除API
     ******************************/

    const destroy = async () => {

      state.errors = [];

      const sheet_group_keys = state.sheets.filter(x => x.isSelected).map(x => x.sheet_group_key);

      if(sheet_group_keys.length == 0){
        state.errors.push("削除対象が選択されていません");
        return;
      }

      if(!window.confirm(`試験情報${sheet_group_keys.length}件を削除します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay", {overlayText: "試験削除中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。", isShowProgress: true});

      let completedCount = 0;

      for(const sheet_group_key of sheet_group_keys){

        await http.delete(`/api/teacher/sheet_destroy/${sheet_group_key}`).then(response => {
          completedCount++;
          context.root.$store.commit("setProgressText", Number.parseFloat(`${completedCount * 100 / sheet_group_keys.length}`).toFixed(2));
        }).catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。失敗した試験は再度削除を行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }

        await resolveAfterMilliSeconds();

      }

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");

      search();
    }

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * 作成日を画面表示文言にコンバート
     ******************************/

    const convertCreatedAt = (created_at: string) => {
      return created_at ? moment(created_at).format('Y年M月D日') : "-";
    };

    /******************************
     * 作成日を画面表示文言にコンバート
     ******************************/

    const convertSheetType = (sheet_type: number) => {
      if(sheet_type == 0){
        return "通常試験";
      }else if(sheet_type == 1){
        return "CBT";
      }else if(sheet_type == 2){
        return "入試";
      }else if(sheet_type == 3){
        return "模試";
      }else{
        return "-";
      }
    };

    const getSearchLimitDate = () => {
      let searchLimitDate = new Date();
      const y = searchLimitDate.getFullYear() - 1;
      const m = ("00" + (searchLimitDate.getMonth()+1)).slice(-2);
      const d = ("00" + searchLimitDate.getDate()).slice(-2);
      return y + "-" + m + "-" + d;
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
      state.condition.created_at_to = getSearchLimitDate();
    };

    /******************************
     * 削除ヘッダチェックボックスクリック
     ******************************/

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {
      state.sheets.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.condition.created_at_to = getSearchLimitDate();
    });

    return {
      ...toRefs(state),
      search,
      convertCreatedAt,
      convertSheetType,
      clearCondition,
      destroy,
    }
  }
});
